import React, { useState, useEffect, useRef } from "react";
import orderService from "../Services/orderService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import { LuEye } from "react-icons/lu";
import { IoIosCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import Head from "../Components/Head";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";

const Order = () => {
  const [order, setOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);
        const response = await orderService.fetchAll();
        const sortedOrders = response.orders.sort((a, b) => {
          return moment(b.created_at).isAfter(moment(a.created_at)) ? 1 : -1;
        });

        setOrder(sortedOrders);
        setLoading(false);
      } catch {}
    };
    getOrders();
  }, []);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <div ref={topRef} />
      {loading ? (
        <div className="">
          <Loading />
        </div>
      ) : (
        <div>
          <div className=" flex flex-col">
            <Head
              heading={"Orders"}
              button_text={"Add Order"}
              navigation={() => navigate("/order/add")}
            />
            <div className="fixed bottom-10 right-10 flex flex-col gap-3 z-50">
              <button
                onClick={() =>
                  topRef.current?.scrollIntoView({ behavior: "smooth" })
                }
                className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:-translate-y-1 transition-all duration-300 group"
                title="Scroll to Top"
              >
                <MdKeyboardDoubleArrowUp className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
              </button>
              <button
                onClick={() =>
                  bottomRef.current?.scrollIntoView({ behavior: "smooth" })
                }
                className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:translate-y-1 transition-all duration-300 group"
                title="Scroll to Bottom"
              >
                <MdKeyboardDoubleArrowDown className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
              </button>
            </div>
            <div className="table-div">
              <table>
                <thead className="border-y-2 text-left w-full text-black text-[10px]">
                  <tr className="w-full text-left">
                    <th className="rounded-tl-lg py-4 w-[1%] pl-4">Sr No.</th>
                    <th className="rounded-tl-lg py-4 w-[2%]">Order No.</th>
                    <th className="w-[3%] py-4">Order Date</th>
                    <th className="w-[4%] py-4">Customer</th>
                    <th className="w-[2%] py-4">Ref No.</th>
                    <th className="w-[1%] py-4">Status</th>
                    <th className="w-[2%] py-4">Order Status</th>
                    <th className="w-[3%] py-4 text-center">Purchase Status</th>
                    <th className="w-[2%] py-4">Amount</th>
                    <th className="w-[2%] py-4">Amount Incl VAT</th>
                    <th className="rounded-tr-lg w-[1%] py-4 text-center">
                      View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order?.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-left"
                    >
                      <td className="py-4 w-[1%] font-bold text-blue-500 pl-4">
                        {index + 1}.
                      </td>
                      <td className="py-4 w-[2%] font-bold">GAP-{value.id}</td>
                      <td className="py-4 w-[3%]">
                        {moment(value.order_date).format("ll")}
                      </td>
                      <td className="py-4 w-[4%] pr-4">{value.company_name}</td>
                      <td className="py-4 w-[2%]">{value.reference_no}</td>
                      <td className="py-4 w-[2%]">
                        <div className="flex">
                          <div
                            className={`${
                              value.payment_status === "paid"
                                ? "bg-green-500 text-green-500"
                                : value.payment_status === "notpaid"
                                  ? "bg-red-500 text-red-500"
                                  : value.payment_status === "check_received"
                                    ? "bg-orange-600 text-orange-600"
                                    : "bg-amber-500 text-amber-500"
                            } px-2 py-1 rounded-md font-semibold bg-opacity-20 uppercase`}
                          >
                            {value.payment_status === "paid"
                              ? "Paid"
                              : value.payment_status === "notpaid"
                                ? "Unpaid"
                                : value.payment_status === "check_received"
                                  ? "Check Received"
                                  : "Partial"}
                          </div>
                        </div>
                      </td>
                      <td className={`py-4 w-[2%] font-semibold`}>
                        <div className="flex">
                          <div
                            className={`px-2 py-1 rounded-md bg-opacity-20 ${
                              value.status === "underprocess"
                                ? "text-red-500 bg-red-500"
                                : value.status === "readytodeliver"
                                  ? "text-amber-500 bg-amber-500"
                                  : value.status === "confirmed"
                                    ? "text-blue-500 bg-blue-500"
                                    : "text-green-500 bg-green-500"
                            }`}
                          >
                            {value.status === "pending"
                              ? "Pending"
                              : value.status === "confirmed"
                                ? "Confirmed"
                                : value.status === "underprocess"
                                  ? "Under Process"
                                  : value.status === "readytodeliver"
                                    ? "Ready To Deliver"
                                    : value.status === "dispatched"
                                      ? "Dispatched"
                                      : "Delivered"}
                          </div>
                        </div>
                      </td>
                      <td className="py-4 w-[3%]">
                        <div className="flex justify-center">
                          {value.purchase === 0 ? (
                            <div className="flex w-fit justify-center items-center content-center text-white rounded-full bg-red-500 p-1">
                              <RxCross2 className="h-2 w-2" />
                            </div>
                          ) : (
                            <div className="flex w-fit justify-center items-center content-center text-white rounded-full bg-green-500">
                              <IoIosCheckmark className="h-4 w-4" />
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="py-4 w-[2%] font-semibold">
                        {value.amount} AED
                      </td>
                      <td className="py-4 w-[2%] font-semibold">
                        {value.vat_amount} AED
                      </td>
                      <td className="py-4 w-[1%] text-center">
                        <button
                          className="text-sky-600"
                          onClick={() =>
                            navigate(`/order/view?invoice=${value.invoice}`)
                          }
                        >
                          <LuEye className="h-4 w-4" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
};

export default Order;
